import React from 'react';
import clsx from 'clsx';
import ComplaintListItem from './ComplaintListItem';
import { Complaint } from '../../../../../types/complaints';

interface ComplaintListProps {
  complaints: Complaint[];
  className: string;
}

const ComplaintList = ({ complaints, className }: ComplaintListProps) => (
  <ul className={clsx('pd-flex pd-flex-col pd-gap-4', className)} data-cy="complaintsList">
    {complaints.map((complaint) => (
      <li key={complaint.complaintId}>
        <ComplaintListItem complaint={complaint} />
      </li>
    ))}
  </ul>
);

export default ComplaintList;
